import { Transport } from './Transport.mjs';
import * as sentryModule from '@sentry/browser';
import { isLogEvent } from '../validation.mjs';

// since this module may be transpiled, we don't have control over how @sentry dependencies are loaded
// so, we look for ECMA style import at 'default' and fall back to require style named exports if not present
/* c8 ignore next */
const sentry = sentryModule.default || sentryModule;

const logToSentryLevel = {
  debug: 'debug',
  error: 'error',
  info: 'info',
  warn: 'warning'
};

/**
 * Transport for writing logger events to Sentry service via Sentry SDK.
 *
 * @class
 * @method handleEvent
 * @static defaultOpts
 * @static initialize
 */
class SentryTransport extends Transport {
  /** @constructor */
  constructor(opts) {
    super(opts);
  }

  /**
   * Event listener function
   *
   * @param {Event} event
   */
  handleEvent(event) {
    if (!isLogEvent(event)) {
      throw new TypeError('invalid event received');
    }

    const detail = event.detail;
    const level = detail.level;
    /* c8 ignore next */
    const context = detail.context || {};

    sentry.withScope( (scope) => {
      /* eslint-disable-next-line security/detect-object-injection */
      scope.setLevel(logToSentryLevel[level]);

      let setContextToExtra = false;
      Object.keys(context).forEach( (key) => {
        /* eslint-disable-next-line security/detect-object-injection */
        const value = context[key];

        if (key === 'user') {
          scope.setUser(value);
          return;
        }

        if (typeof value === 'string' && value.length > 0 && value.length <= 200) {
          scope.setTag(key, value);
          return;
        }

        // we couldn't do anything with this key, so we set flag to set full context to extra
        setContextToExtra = true;
      });

      if (setContextToExtra) {
        scope.setExtra('context', context);
      }

      if (detail.data) {
        scope.setExtra('data', detail.data);
      }

      sentry.captureEvent(event);
    });
  }
}

SentryTransport.defaultOpts = Object.freeze({});

export {
  SentryTransport as default,
  SentryTransport
};
